import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { DialogFooter } from "@/components/ui/dialog";

/**
 * TIP step of the Pay wizard. Presents three configurable presets +
 * Custom + No Tip. Kept dumb — all currency math and step transitions
 * stay in PaymentModal, we only shuffle the JSX out.
 */
const TipStep = ({
  subtotal,
  tipPresets,
  tipAmount, setTipAmount,
  customTipOpen, setCustomTipOpen,
  customTipInput, setCustomTipInput,
  commitCustomTip,
  applyTipPct,
  onCancel,
  onNext,
}) => (
  <div className="space-y-3 mt-2" data-testid="wizard-tip-step">
    <div className="grid grid-cols-3 gap-2">
      {tipPresets.map((pct, i) => (
        <Button
          key={pct + "-" + i}
          variant={tipAmount === parseFloat((subtotal * pct / 100).toFixed(2)) ? "default" : "outline"}
          onClick={() => applyTipPct(pct)}
          className="h-16 flex flex-col gap-0"
          data-testid={`tip-preset-${i + 1}`}
        >
          <span className="text-lg font-semibold">{pct}%</span>
          <span className="text-xs opacity-75 font-mono">${(subtotal * pct / 100).toFixed(2)}</span>
        </Button>
      ))}
    </div>
    <div className="grid grid-cols-2 gap-2">
      <Button
        variant={customTipOpen ? "default" : "outline"}
        onClick={() => setCustomTipOpen(true)}
        className="h-12"
        data-testid="tip-custom-btn"
      >
        Custom Amount
      </Button>
      <Button
        variant={tipAmount === 0 ? "default" : "outline"}
        onClick={() => setTipAmount(0)}
        className="h-12"
        data-testid="tip-none-btn"
      >
        No Tip
      </Button>
    </div>

    {customTipOpen && (
      <div className="rounded-lg border border-border p-3 space-y-2 bg-secondary/30" data-testid="tip-custom-row">
        <Label>Enter custom tip ($)</Label>
        <div className="flex gap-2">
          <Input
            type="number"
            placeholder="e.g. 4.50"
            value={customTipInput}
            onChange={(e) => setCustomTipInput(e.target.value)}
            className="font-mono"
            autoFocus
            data-testid="tip-custom-input"
          />
          <Button onClick={commitCustomTip} data-testid="tip-custom-apply">Apply</Button>
        </div>
      </div>
    )}

    <DialogFooter className="pt-2">
      <Button variant="outline" onClick={onCancel}>Cancel</Button>
      <Button onClick={onNext} className="min-w-[140px]" data-testid="wizard-next-loyalty">
        Next: Loyalty
      </Button>
    </DialogFooter>
  </div>
);

export default TipStep;
